import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Card, CardHeader, Col, Container, Input, Modal, Row, Table } from "reactstrap";
import Swal from "sweetalert2";
import { authHeader } from "../../../services/fack.backend";
import CreateGlobalProcedure from "./form/create/createGlobalProcedure";
import EditGlobalProcedure from "./form/edit/editGlobalProcedure";
import ImportProcedure from "./importProcedure/importProcedure";
import ViewGlobalProcedure from "./view/viewGlobalProcedure";

const GlobalProcedure = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [procedures, setProcedures] = useState({})
  const [isOpenCreateModal, setIsOpenCreateModal] = useState(false)
  const [isOpenEditModal, setIsOpenEditModal] = useState(false)
  const [isOpenViewModal, setIsOpenViewModal] = useState(false)
  const [isOpenImportModal, setIsOpenImportModal] = useState(false)
  const [singleProcedure, setSingleProcedure] = useState({})
  const [searchKeyword, setSearchKeyword] = useState('')
  const [filteredProcedures, setFilteredProcedures] = useState([])

  const openCreateModal = () => {
    setIsOpenCreateModal(true)
  }

  const closeCreateModal = () => {
    setIsOpenCreateModal(false)
  }

  const openEditModal = (value) => {
    setSingleProcedure(value)
    setIsOpenEditModal(true)
  }

  const closeEditModal = () => {
    setIsOpenEditModal(false)
  }

  const openViewModal = (value) => {
    setSingleProcedure(value)
    setIsOpenViewModal(true)
  }

  const closeViewModal = () => {
    setIsOpenViewModal(false)
  }

  const openImportModal = () => {
    setIsOpenImportModal(true)
  }

  const closeImportModal = () => {
    setIsOpenImportModal(false)
  }

  useEffect(() => {
    fetchProcedures()
  }, [])

  const fetchProcedures = async () => {
    setIsLoading(true)
    await axios.get(`${process.env.REACT_APP_API_URL}/api/globalProcedure`, { headers: authHeader() })
      .then(res => {
        setProcedures(res.data)
        setFilteredProcedures(res.data)
        setIsLoading(false)
      })
  }

  const deleteProcedure = async (procedure) => {
    Swal.fire({
      title: 'Cuidado!',
      text: `Você deseja deletar o Procedimento Global ${procedure.name}`,
      icon: 'warning',
      confirmButtonText: 'Sim',
      denyButtonText: 'Não',
      showDenyButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`${process.env.REACT_APP_API_URL}/api/globalProcedure/` + procedure.id, { headers: authHeader() }).then(response => {
          Swal.fire('Procedimento Global deletado com sucesso!', '', 'success')
          fetchProcedures()
        }).catch(error => {
          Swal.fire('Ocorreu um erro, tente novamente!', '', 'error')
        })
      } else if (result.isDenied) {
        Swal.close()
      }
    })
  }

  const handleSearch = (e) => {

    console.log(procedures)
    const temp = procedures.filter((item) => {
      return item.code.toLowerCase().indexOf(e.toLowerCase()) !== -1;
    });

    setFilteredProcedures(temp)
  }

  return (
    <React.Fragment>
      <Container fluid={true}>
        <Modal isOpen={isOpenImportModal}>
          <ImportProcedure
            onCloseModal={closeImportModal}
            fetchProcedures={fetchProcedures}
            isGlobal={true}
          />
        </Modal>
        <Modal isOpen={isOpenCreateModal}>
          <CreateGlobalProcedure
            onCloseModal={closeCreateModal}
            fetchProcedures={fetchProcedures}
          />
        </Modal>
        <Modal isOpen={isOpenEditModal}>
          <EditGlobalProcedure
            onCloseModal={closeEditModal}
            fetchProcedures={fetchProcedures}
            singleProcedure={singleProcedure}
          />
        </Modal>
        <Modal isOpen={isOpenViewModal}>
          <ViewGlobalProcedure
            onCloseModal={closeViewModal}
            singleProcedure={singleProcedure}
          />
        </Modal>
        <Row>
          <Col sm="12">
            <Card>
              <Col sm="12">
                <Card>
                  <CardHeader>
                    <h5>{"Procedimentos Globais"}</h5>
                    <span> {"Veja todos os Procedimentos Globais, crie, edite ou delete-os."}</span>
                    <div className="pull-right">
                      <Button className="mr-5" color='primary' onClick={() => openCreateModal()}><i className="fa fa-plus"></i> Procedimento Global</Button>
                      <Button color='success' onClick={() => openImportModal()}><i className="fa fa-plus"></i> Importar</Button>
                      <div className="search">
                        <div className="mb-3">
                          <Input
                            className="form-control"
                            type="text"
                            placeholder="Pesquise um Código"
                            defaultValue={searchKeyword}
                            onChange={(e) => handleSearch(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </CardHeader>
                  {isLoading
                    ?
                    <div className="loader-box">
                      <div className="loader-7"></div>
                    </div>
                    :
                    <div className="table-responsive">
                      <Table className="table-border-horizontal">
                        <thead>
                          <tr>
                            <th scope="col">{"Código"}</th>
                            <th scope="col-2 text-truncate">{"Descrição"}</th>
                            <th scope="col">{"Porte"}</th>
                            <th scope="col">{""}</th>
                          </tr>
                        </thead>
                        {filteredProcedures.map((value, key) => (
                          <tbody>
                            <tr key={key}>
                              <td key={key}>{value.code}</td>
                              <td key={key}>{value.description}</td>
                              <td key={key}>{value.size !== null ? value.size.description : ''}</td>
                              <td className="table-action-button">
                                <i id="look-button" className="fa fa-eye" style={{ cursor: "pointer" }} onClick={() => openViewModal(value)}></i>
                                <i id={`edit-button`} className="fa fa-pencil" style={{ cursor: "pointer" }} onClick={() => openEditModal(value)}></i>
                                <i id={`delete-button`} className="fa fa-trash-o" style={{ cursor: "pointer" }} onClick={() => deleteProcedure(value)}></i>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                      </Table>
                    </div>
                  }
                </Card>
              </Col>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
}

export default GlobalProcedure;